import useClassNames from '@medflex/hooks/useClassNames';
import { format } from '@medflex/i18n';
import * as PropTypes from 'prop-types';
import * as React from 'react';

const ChatMessageStreamSeparator = ({ date, info, className, ...props }) => {
  const cn = useClassNames(
    () => [
      'flex',
      date && info && 'justify-between',
      !date && info && 'justify-end',
      'px-8',
      'mt-8',
      'mb-4',
      'text-xs',
      'uppercase',
      'font-semibold',
      'border-b',
      'border-b-slate-200',
      className,
    ],
    [className],
  );
  return (
    <header data-component="ChatMessageStreamSeparator" className={cn} {...props}>
      {date && <span>{format(date, 'dddd, DD. MMMM YYYY')}</span>}
      {info && <span className="self-end">{info}</span>}
    </header>
  );
};

ChatMessageStreamSeparator.propTypes = {
  date: PropTypes.string,
  info: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ChatMessageStreamSeparator;
